import { LoginNavigationSkeleton } from "@/types/contentful/login/login-navigation";
import { Entry } from "contentful";
import { ExternalLinkSkeleton } from "@/types/contentful/common/external-link";
import mapExternalLink, { MappedExternalLink } from "../common/externalLinkMapper";

// Define the interface for the mapped navigation data
export interface IMappedLoginNavigation {
  login: string;
  loggedIn: string;
  logout: string;
  passengerLink: MappedExternalLink;
  professionalLink: MappedExternalLink;
}

const mappedLoginNavigation = (entry: Entry<LoginNavigationSkeleton>): IMappedLoginNavigation => ({
  login: entry.fields.login?.toString() ?? "",
  loggedIn: entry.fields.loggedIn?.toString() ?? "",
  logout: entry.fields.logout?.toString() ?? "",
  passengerLink: mapExternalLink(entry.fields.passengerLink as Entry<ExternalLinkSkeleton> | undefined),
  professionalLink: mapExternalLink(entry.fields.professionalLink as Entry<ExternalLinkSkeleton> | undefined)
});

export default mappedLoginNavigation;